import React, {

  useEffect,

  useState,

} from "react";



import I from "./Icon";

import BC from "./Breadcrumb";

import apiService from "../services/apiService";





// Use the browser's local date, not UTC, for the date input limit.
// Delivery is stored in the existing Description until the API has a dedicated field.
const COURIER_CHARGE_PER_BOOK = 50;

const DELIVERY_PREFIX = "[Delivery Method: ";
const getInitialDescription = (initial) => String(
  initial?.notes ?? initial?.Notes ?? initial?.description ?? initial?.Description ?? ""
);
const getInitialDelivery = (initial) => {
  const direct = initial?.deliveryMethod ?? initial?.DeliveryMethod;
  if (direct === "Courier" || direct === "Shop Pickup") return direct;
  const match = getInitialDescription(initial).match(/^\[Delivery Method: (Courier|Shop Pickup)\](?:\s*\|\s*)?/);
  return match?.[1] ?? "";
};
const getInitialNotes = (initial) =>
  getInitialDescription(initial).replace(/^\[Delivery Method: (?:Courier|Shop Pickup)\](?:\s*\|\s*)?/, "");

const getTodayLocal = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const ADD_TEACHER_BOOK_ASSIGN_API =

  "TeacherBookAssign/addTeacherBookAssign";



const UPDATE_TEACHER_BOOK_ASSIGN_API =

  "TeacherBookAssign/updateTeacherBookAssign";

const TEACHER_API =

  "Teacher/getAllTeacher";



const SCHOOL_API =

  "School/getAllSchool";



const BOOK_API =

  "BookMaster/getPaginatedBookMasters";





const showNotification = (type, message) => {

  if (

    typeof document === "undefined" ||

    typeof window === "undefined"

  ) {

    return;

  }



  const existingNotification =

    document.getElementById(

      "book-purchase-form-notification"

    );



  if (existingNotification) {

    existingNotification.remove();

  }



  const notification =

    document.createElement("div");



  notification.id =

    "book-purchase-form-notification";



  notification.textContent =

    `${type === "success" ? "✓" : "✕"} ${message}`;



  Object.assign(

    notification.style,

    {

      position: "fixed",

      top: "20px",

      right: "20px",

      zIndex: "99999",

      minWidth: "280px",

      maxWidth: "420px",

      padding: "12px 16px",

      borderRadius: "8px",

      backgroundColor:

        type === "success"

          ? "#d1e7dd"

          : "#f8d7da",

      color:

        type === "success"

          ? "#0f5132"

          : "#842029",

      border:

        type === "success"

          ? "1px solid #badbcc"

          : "1px solid #f5c2c7",

      fontSize: "14px",

      fontWeight: "600",

      boxShadow:

        "0 4px 12px rgba(0,0,0,0.15)",

    }

  );



  document.body.appendChild(

    notification

  );



  window.setTimeout(() => {

    if (notification.parentNode) {

      notification.remove();

    }

  }, 3000);

};



const getApiErrorMessage = (

  error,

  fallback

) => {

  const data =

    error?.response?.data;



  if (

    typeof data === "string" &&

    data.trim()

  ) {

    return data;

  }



  if (

    data &&

    typeof data === "object"

  ) {

    if (

      data?.errors &&

      typeof data.errors === "object"

    ) {

      const validationErrors =

        Object.values(data.errors)

          .flat()

          .filter(Boolean)

          .join(" ");



      if (validationErrors) {

        return validationErrors;

      }

    }



    return (

      data?.failureReason ||

      data?.FailureReason ||

      data?.message ||

      data?.Message ||

      data?.title ||

      data?.error ||

      error?.message ||

      fallback

    );

  }



  return (

    error?.message ||

    fallback

  );

};



// ==========================================

// RESPONSE HELPERS

// ==========================================



const extractList = (response) => {

  const data =

    response?.data ??

    response;



  if (Array.isArray(data)) {

    return data;

  }



  const output =

    data?.output ??

    data?.Output ??

    data?.data ??

    data?.Data ??

    data?.result ??

    data?.Result ??

    data;



  if (Array.isArray(output)) {

    return output;

  }



  const candidates = [

    output?.result,

    output?.Result,



    output?.items,

    output?.Items,



    output?.records,

    output?.Records,



    output?.rows,

    output?.Rows,



    output?.data,

    output?.Data,



    output?.teachers,

    output?.Teachers,



    output?.schools,

    output?.Schools,



    output?.books,

    output?.Books,



    output?.bookMasters,

    output?.BookMasters,

  ];



  return (

    candidates.find(

      Array.isArray

    ) || []

  );

};



// ==========================================

// ACTIVE CHECK

// ==========================================



const isActiveRecord = (

  item

) => {

  const value =

    item?.isActive ??

    item?.IsActive ??

    item?.status ??

    item?.Status;



  /*

    API मध्ये active field नसेल

    तर record active मानतो.

  */

  if (

    value === undefined ||

    value === null

  ) {

    return true;

  }



  if (

    value === true ||

    value === 1 ||

    value === "1"

  ) {

    return true;

  }



  const text =

    String(value)

      .trim()

      .toLowerCase();



  return (

    text === "true" ||

    text === "active"

  );

};



// ==========================================

// NORMALIZE TEACHER

// ==========================================



const normalizeTeacher = (

  teacher

) => {

  const id =

    teacher?.id ??

    teacher?.Id ??

    teacher?.teacherId ??

    teacher?.TeacherId;



  const generatedName = [

    teacher?.firstName ??

    teacher?.FirstName,



    teacher?.middleName ??

    teacher?.MiddleName,



    teacher?.lastName ??

    teacher?.LastName,

  ]

    .filter(Boolean)

    .join(" ");



  const name =

    teacher?.fullName ??

    teacher?.FullName ??

    teacher?.teacherName ??

    teacher?.TeacherName ??

    teacher?.name ??

    teacher?.Name ??

    generatedName ??

    "";



  return {

    ...teacher,

    id,

    name,

  };

};



// ==========================================

// NORMALIZE SCHOOL

// ==========================================



const normalizeSchool = (

  school

) => ({

  ...school,



  id:

    school?.id ??

    school?.Id ??

    school?.schoolId ??

    school?.SchoolId,



  schoolName:

    school?.schoolName ??

    school?.SchoolName ??

    school?.name ??

    school?.Name ??

    school?.school ??

    "",

});



// ==========================================

// NORMALIZE BOOK

// ==========================================



const parseJson = (value) => {
  if (typeof value !== "string") return value;
  try { return JSON.parse(value); } catch { return value; }
};

const unwrapBook = (value) => {
  let current = value;
  for (let i = 0; i < 8; i += 1) {
    current = parseJson(current);
    if (Array.isArray(current)) return current[0] ?? null;
    if (!current || typeof current !== "object") return null;
    const next = current.output ?? current.Output ?? current.result ?? current.Result ??
      current.data ?? current.Data ?? current.book ?? current.Book ??
      current.bookMaster ?? current.BookMaster;
    if (next == null) return current;
    current = next;
  }
  return current;
};

const normalizeBook = (book) => ({
  ...book,
  id: book?.id ?? book?.Id ?? book?.bookId ?? book?.BookId ?? book?.bookMasterId ?? book?.BookMasterId,
  bookCode: book?.bookCode ?? book?.BookCode ?? "",
  competitiveExams: String(book?.competitiveExams ?? book?.CompetitiveExams ?? "").trim(),
  bookName: book?.bookName ?? book?.BookName ?? "",
  amount: Number(book?.amount ?? book?.Amount ?? book?.totalAmount ?? book?.TotalAmount ?? 0),
});

const getBookDetails = (record) => {
  const raw = record?.teaBooAssDetlst ?? record?.TeaBooAssDetlst ??
    record?.bokDetlst ?? record?.BokDetlst ?? record?.bookMasterDetails ??
    record?.BookMasterDetails ?? record?.details ?? record?.Details ?? [];
  const decoded = parseJson(raw);
  return Array.isArray(decoded) ? decoded : decoded && typeof decoded === "object" ? [decoded] : [];
};

const makeBookOptions = (master) => {
  const details = getBookDetails(master);
  const masterId = Number(master?.id ?? master?.Id ?? 0);
  const masterCode = master?.bookCode ?? master?.BookCode ?? "";
  const exam = String(master?.competitiveExams ?? master?.CompetitiveExams ?? "").trim();
  if (!details.length) return master?.bookName ? [{...normalizeBook(master), optionKey: `${masterId}:master`, competitiveExams: exam}] : [];
  return details.filter(isActiveRecord).map((detail, index) => ({
    id: masterId,  // TeacherBookAssign.BookId points to the BookMaster ID.
    optionKey: `${masterId}:${detail?.id ?? detail?.Id ?? 0}:${index}`,
    bookCode: masterCode,
    competitiveExams: exam,
    bookName: detail?.bookName ?? detail?.BookName ?? "",
    amount: Number(detail?.amount ?? detail?.Amount ?? 0),
    detailId: detail?.id ?? detail?.Id ?? 0,
  })).filter((book) => book.bookName);
};

// ==========================================

// COMPONENT

// ==========================================



export default function BookAddForm({

  schools = [],

  allTeachers = [],

  books = [],

  initial = null,

  onSave,

  onBack,

}) {

  const isEdit =

    !!initial;



  // ==========================================

  // STATES

  // ==========================================



  const [

    saving,

    setSaving,

  ] = useState(false);



  const [

    masterLoading,

    setMasterLoading,

  ] = useState(false);

  const [fieldErrors, setFieldErrors] = useState({});



  const [

    teacherOptions,

    setTeacherOptions,

  ] = useState([]);



  const [

    schoolOptions,

    setSchoolOptions,

  ] = useState([]);



  const [

    bookOptions,

    setBookOptions,

  ] = useState([]);



  const [examOptions, setExamOptions] = useState([]);
  const [booksLoading, setBooksLoading] = useState(false);

  // ==========================================

  // FORM STATE

  // ==========================================



  const [f, setF] =

    useState({

      teacher:

        initial?.teacher ??

        initial?.TeacherName ??

        initial?.name ??

        "",



      teacherId:

        initial?.teacherId ??

        initial?.TeacherId ??

        "",



      school:

        initial?.school ??

        initial?.schoolName ??

        initial?.SchoolName ??

        "",

      examName: String(initial?.competitiveExams ?? initial?.CompetitiveExams ??
        initial?.examName ?? initial?.ExamName ?? ""),
      deliveryMethod: getInitialDelivery(initial),
      notes: getInitialNotes(initial),

      schoolId:

        initial?.schoolId ??

        initial?.SchoolId ??

        "",

    });



  // ==========================================

  // EMPTY BOOK

  // ==========================================



  const emptyBook = () => ({

    rowId:

      Date.now() +

      Math.random(),



    id: 0,



    assignBookId: 0,



    bookId: "",



    bookCode: "",



    bookName: "",



    amount: 0,



    purchaseDate: "",



    purchased: 0,



    students: 0,



    returnBooks: 0,



    returnAmount: 0,



    isActive: true,



    notes: "",

  });



  // ==========================================

  // BOOK ITEMS

  // ==========================================



  const [

    bookItems,

    setBookItems,

  ] = useState(() => {

    // ======================================

    // MULTIPLE EXISTING BOOKS

    // ======================================



    if (

      Array.isArray(

        initial?.books

      ) &&

      initial.books.length > 0

    ) {

      return initial.books.map(

        (item) => ({

          rowId:

            item?.rowId ??

            Date.now() +

            Math.random(),



          id:

            item?.id ??

            item?.Id ??

            0,



          assignBookId:

            item?.assignBookId ??

            item?.AssignBookId ??

            initial?.id ??

            initial?.Id ??

            initial?.assignBookId ??

            initial?.AssignBookId ??

            0,



          bookId:

            item?.bookId ??

            item?.BookId ??

            "",



          bookCode:

            item?.bookCode ??

            item?.BookCode ??

            "",



          bookName:

            item?.bookName ??

            item?.BookName ??

            "",



          amount:

            Number(

              item?.amount ??

              item?.Amount ??

              0

            ),



          purchaseDate:

            item?.purchaseDate ??

            item?.documentDate ??

            item?.DocumentDate ??

            "",



          purchased:

            Number(

              item?.purchased ??

              item?.booksPurchased ??

              item?.qty ??

              item?.Qty ??

              0

            ),



          students:

            Number(

              item?.students ??

              item?.studentCount ??

              item?.StudentCount ??

              0

            ),



          returnBooks:

            Number(

              item?.returnBooks ??

              item?.returnQty ??

              item?.ReturnQty ??

              0

            ),



          returnAmount:

            Number(

              item?.returnAmount ??

              item?.ReturnAmount ??

              0

            ),



          isActive:

            item?.isActive ??

            item?.IsActive ??

            true,



          notes:

            item?.notes ??

            item?.description ??

            item?.Description ??

            "",

        })

      );

    }



    // ======================================

    // SINGLE EXISTING BOOK

    // ======================================



    if (initial) {

      return [

        {

          rowId:

            Date.now() +

            Math.random(),



          id:

            initial?.detailId ??

            initial?.DetailId ??

            initial?.books?.[0]?.id ??

            initial?.books?.[0]?.Id ??

            0,



          assignBookId:

            initial?.assignBookId ??

            initial?.AssignBookId ??

            initial?.id ??

            initial?.Id ??

            0,



          bookId:

            initial?.bookId ??

            initial?.BookId ??

            "",



          bookCode:

            initial?.bookCode ??

            initial?.BookCode ??

            "",



          bookName:

            initial?.bookName ??

            initial?.BookName ??

            "",



          amount:

            Number(

              initial?.amount ??

              initial?.Amount ??

              0

            ),



          purchaseDate:

            initial?.purchaseDate ??

            initial?.documentDate ??

            initial?.DocumentDate ??

            "",



          purchased:

            Number(

              initial?.purchased ??

              initial?.booksPurchased ??

              initial?.qty ??

              initial?.Qty ??

              0

            ),



          students:

            Number(

              initial?.students ??

              initial?.studentCount ??

              initial?.StudentCount ??

              0

            ),



          returnBooks:

            Number(

              initial?.returnBooks ??

              initial?.returnQty ??

              initial?.ReturnQty ??

              0

            ),



          returnAmount:

            Number(

              initial?.returnAmount ??

              initial?.ReturnAmount ??

              0

            ),



          isActive:

            initial?.isActive ??

            initial?.IsActive ??

            true,



          notes:

            initial?.notes ??

            initial?.description ??

            initial?.Description ??

            "",

        },

      ];

    }



    // ======================================

    // ADD MODE

    // ======================================



    return [

      emptyBook(),

    ];

  });



  // ==========================================

  // MESSAGE

  // ==========================================



  const showMessage = (

    message,

    type = "err"

  ) => {

    const normalizedType =

      String(type || "")

        .trim()

        .toLowerCase();



    showNotification(

      [

        "success",

        "suc",

        "ok",

      ].includes(

        normalizedType

      )

        ? "success"

        : "error",

      message

    );

  };



  // ==========================================

  // LOAD TEACHER

  // ==========================================



  const loadTeachers =

    async () => {

      try {

        const response =

          await apiService.get(

            TEACHER_API

          );



        console.log(

          "Teacher API Response:",

          response?.data

        );



        const list =

          extractList(

            response

          );



        const activeTeachers =

          list

            .filter(

              isActiveRecord

            )

            .map(

              normalizeTeacher

            )

            .filter(

              (teacher) =>

                teacher?.id &&

                teacher?.name

            );



        setTeacherOptions(

          activeTeachers

        );



        console.log(

          "Active Teachers:",

          activeTeachers

        );

      } catch (error) {

        console.error(

          "Teacher API Error:",

          error

        );



        /*

          API fail झाला तर

          props मधला data fallback.

        */

        const fallback =

          (allTeachers || [])

            .filter(

              isActiveRecord

            )

            .map(

              normalizeTeacher

            );



        setTeacherOptions(

          fallback

        );



        showNotification(

          "error",

          getApiErrorMessage(

            error,

            "Unable to load teachers"

          )

        );

      }

    };



  // ==========================================

  // LOAD SCHOOLS

  // ==========================================



  const loadSchools =

    async () => {

      try {

        const response =

          await apiService.get(

            SCHOOL_API

          );



        console.log(

          "School API Response:",

          response?.data

        );



        const list =

          extractList(

            response

          );



        const activeSchools =

          list

            .filter(

              isActiveRecord

            )

            .map(

              normalizeSchool

            )

            .filter(

              (school) =>

                school?.id &&

                school?.schoolName

            );



        setSchoolOptions(

          activeSchools

        );



        console.log(

          "Active Schools:",

          activeSchools

        );

      } catch (error) {

        console.error(

          "School API Error:",

          error

        );



        const fallback =

          (schools || [])

            .filter(

              isActiveRecord

            )

            .map(

              normalizeSchool

            );



        setSchoolOptions(

          fallback

        );



        showNotification(

          "error",

          getApiErrorMessage(

            error,

            "Unable to load schools"

          )

        );

      }

    };



  // ==========================================

  // LOAD ACTIVE BOOKS

  // ==========================================



  const loadBooks = async () => {
    setBooksLoading(true);
    try {
      const response = await apiService.post(BOOK_API, {
        Page: 1, PageSize: 1000, SearchTerm: "", SortDirection: "DESC", SortField: "Id",
      });
      const masters = extractList(response).filter(isActiveRecord).map(normalizeBook);
      const examNames = [...new Set(masters.map((m) => m.competitiveExams).filter(Boolean))];
      setExamOptions(examNames);

      // Pagination returns only the master record. GetById supplies the
      // separate BookMasterDetails rows (teaBooAssDetlst).
      const expanded = await Promise.all(masters.map(async (master) => {
        try {
          const detailResponse = await apiService.get(`BookMaster/getBookMasterById/${master.id}`);
          const fullBook = unwrapBook(detailResponse?.data);
          return makeBookOptions({ ...master, ...(fullBook || {}) });
        } catch (error) {
          console.warn("Could not load details for BookMaster", master.id, error);
          return makeBookOptions(master);
        }
      }));
      const options = expanded.flat();
      setBookOptions(options);
      if (!options.length && masters.length) {
        showNotification("error", "Book Master details could not be loaded. Check getBookMasterById API.");
      }
    } catch (error) {
      console.error("Book Master API Error:", error);
      const fallbackMasters = (books || []).filter(isActiveRecord).map(normalizeBook);
      setExamOptions([...new Set(fallbackMasters.map((m) => m.competitiveExams).filter(Boolean))]);
      setBookOptions(fallbackMasters.flatMap(makeBookOptions));
      showNotification("error", getApiErrorMessage(error, "Unable to load books"));
    } finally {
      setBooksLoading(false);
    }
  };

  // ==========================================

  // LOAD ALL MASTER DATA

  // ==========================================



  useEffect(() => {

    const loadMasterData =

      async () => {

        try {

          setMasterLoading(

            true

          );



          await Promise.all([

            loadTeachers(),

            loadSchools(),

            loadBooks(),

          ]);

        } finally {

          setMasterLoading(

            false

          );

        }

      };



    loadMasterData();



    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);



  // Match an existing assignment to its exam and available book options.
  useEffect(() => {
    if (!isEdit || !bookOptions.length) return;
    const savedId = String(initial?.bookId ?? initial?.BookId ?? initial?.books?.[0]?.bookId ?? "");
    const match = bookOptions.find((option) => String(option.id) === savedId);
    if (match) {
      setF((previous) => ({ ...previous, examName: previous.examName || match.competitiveExams }));
    }
    setBookItems((previous) => previous.map((item) => {
      if (item.optionKey || !item.bookId) return item;
      const found = bookOptions.find((option) => String(option.id) === String(item.bookId) &&
        (!item.bookName || option.bookName.toLowerCase() === String(item.bookName).toLowerCase())) ||
        bookOptions.find((option) => String(option.id) === String(item.bookId));
      return found ? { ...item, optionKey: found.optionKey, bookCode: found.bookCode,
        bookName: item.bookName || found.bookName, amount: item.amount || found.amount } : item;
    }));
  }, [bookOptions, isEdit, initial]);

  const handleExam = (value) => {
    setF((previous) => ({ ...previous, examName: value }));
    setBookItems((previous) => previous.map((item) => ({
      ...item, bookId: "", optionKey: "", bookCode: "", bookName: "", amount: 0,
    })));
    setFieldErrors((previous) => { const updated = { ...previous }; delete updated.examName; return updated; });
  };

  const filteredBookOptions = bookOptions.filter((option) =>
    option.competitiveExams.toLowerCase() === String(f.examName).trim().toLowerCase()
  );

  // ==========================================

  // TEACHER CHANGE

  // ==========================================



  const handleTeacher = (

    value

  ) => {

    const teacher =

      teacherOptions.find(

        (item) =>

          String(item?.id) === String(value)

      );



    if (teacher) {

      setF(

        (previous) => ({

          ...previous,



          teacherId:

            teacher.id,



          teacher:

            teacher.name,

        })

      );

    } else {

      setF(

        (previous) => ({

          ...previous,



          teacherId: "",



          teacher: "",

        })

      );

    }

  setFieldErrors((previous) => {
      const updated = { ...previous };
      delete updated.teacherId;
      return updated;
    });
  };



  // ==========================================

  // SCHOOL CHANGE

  // ==========================================



  const handleSchool = (

    value

  ) => {

    const school =

      schoolOptions.find(

        (item) =>

          String(

            item?.id

          ) ===

          String(value)

      );



    if (school) {

      setF(

        (previous) => ({

          ...previous,



          schoolId:

            school.id,



          school:

            school.schoolName,

        })

      );

    } else {

      setF(

        (previous) => ({

          ...previous,



          schoolId: "",



          school: "",

        })

      );

    }

  setFieldErrors((previous) => {
      const updated = { ...previous };
      delete updated.schoolId;
      return updated;
    });
  };



  // ==========================================

  // UPDATE BOOK FIELD

  // ==========================================



  const updateBook = (index, key, value) => {
    setBookItems((previous) =>
      previous.map((item, itemIndex) =>
        itemIndex === index ? { ...item, [key]: value } : item
      )
    );

    setFieldErrors((previous) => {
      const updated = { ...previous };
      delete updated[`books.${index}.${key}`];
      return updated;
    });
  };



  // ==========================================

  // BOOK CHANGE

  // ==========================================



  const handleBook = (

    index,

    value

  ) => {

    const selectedBook =

      filteredBookOptions.find((item) => String(item?.optionKey) === String(value));



    if (selectedBook) {
      // A book detail can only be selected in one row of this assignment.
      const alreadySelected = bookItems.some((row, rowIndex) =>
        rowIndex !== index && String(row.optionKey || "") === String(selectedBook.optionKey)
      );
      if (alreadySelected) {
        showMessage("This book is already selected in another row");
        return;
      }

      setBookItems(

        (previous) =>

          previous.map(

            (

              item,

              itemIndex

            ) =>

              itemIndex ===

                index

                ? {

                  ...item,



                  bookId:

                    selectedBook.id,

                  optionKey: selectedBook.optionKey,



                  bookCode:

                    selectedBook.bookCode,



                  bookName:

                    selectedBook.bookName,



                  amount:

                    Number(

                      selectedBook.amount ??

                      0

                    ),

                }

                : item

          )

      );

    } else {

      setBookItems(

        (previous) =>

          previous.map(

            (

              item,

              itemIndex

            ) =>

              itemIndex ===

                index

                ? {

                  ...item,



                  bookId: "",

                  optionKey: "",

                  bookCode: "",



                  bookName: "",



                  amount: 0,

                }

                : item

          )

      );

    }

  setFieldErrors((previous) => {
      const updated = { ...previous };
      delete updated[`books.${index}.bookId`];
      return updated;
    });
  };



  // ==========================================

  // ADD ANOTHER BOOK

  // ==========================================



  const addBook = () => {

    setBookItems(

      (previous) => [

        ...previous,

        emptyBook(),

      ]

    );

  };



  // ==========================================

  // REMOVE BOOK

  // ==========================================



  const removeBook = (

    index

  ) => {

    if (

      bookItems.length ===

      1

    ) {

      return;

    }



    setBookItems(

      (previous) =>

        previous.filter(

          (

            _,

            itemIndex

          ) =>

            itemIndex !==

            index

        )

    );

  };



  // ==========================================

  // BUILD FORM DATA

  // ==========================================



  const buildFormData =

    () => ({

      teacherId:

        Number(

          f.teacherId

        ),



      teacher:

        f.teacher,



      schoolId:

        Number(

          f.schoolId

        ),



      school:

        f.school,

      competitiveExams: f.examName,
      examName: f.examName,

      notes: f.notes,
      deliveryMethod: f.deliveryMethod,

      books:

        bookItems.map(

          (item) => ({

            id:

              Number(

                item.id ??

                0

              ),



            assignBookId:

              Number(

                item.assignBookId ??

                initial?.id ??

                initial?.Id ??

                initial?.assignBookId ??

                initial?.AssignBookId ??

                0

              ),



            bookId:

              Number(

                item.bookId

              ),



            bookCode:

              item.bookCode,



            bookName:

              item.bookName,



            amount:

              Number(

                item.amount

              ) || 0,

            courierCharges: f.deliveryMethod === "Courier" ? COURIER_CHARGE_PER_BOOK : 0,



            purchaseDate:

              item.purchaseDate,



            purchased:

              Number(

                item.purchased

              ) || 0,



            students:

              Number(

                item.students

              ) || 0,



            returnBooks:

              Number(

                item.returnBooks

              ) || 0,



            returnAmount:

              Number(

                item.returnAmount

              ) || 0,



            isActive:

              item.isActive ??

              true,



            notes:

              item.notes,

          })

        ),

    });



  // ==========================================

  // SAVE

  // ADD + UPDATE API BINDING

  // ==========================================



  const handleSave = async () => {
    if (saving) {
      return;
    }

    const validationErrors = {};

    if (!f.teacherId) {
      validationErrors.teacherId = "Teacher is required";
    }

    if (!f.schoolId) {
      validationErrors.schoolId = "School is required";
    }

    if (!f.examName) {
      validationErrors.examName = "Competitive Exam is required";
    }
    if (!f.deliveryMethod) {
      validationErrors.deliveryMethod = "Please select Courier or Shop Pickup";
    }

    const selectedBookKeys = new Set();
    bookItems.forEach((item, index) => {
      if (item.optionKey) {
        if (selectedBookKeys.has(String(item.optionKey))) {
          validationErrors[`books.${index}.bookId`] = "This book is already selected in another row";
        }
        selectedBookKeys.add(String(item.optionKey));
      }
      if (item.purchaseDate && String(item.purchaseDate).slice(0, 10) > getTodayLocal()) {
        validationErrors[`books.${index}.purchaseDate`] = "Future purchase dates are not allowed";
      }
      // In Edit mode, already-saved books must remain editable even when the
      // current Book Master API does not return that old title as an active option.
      const isExistingEditBook = isEdit && Number(item.id) > 0 &&
        Number(item.bookId) > 0 && Boolean(String(item.bookName || "").trim());
      if (!isExistingEditBook && (!item.bookId || !filteredBookOptions.some((b) => String(b.id) === String(item.bookId) &&
        (!item.optionKey || b.optionKey === item.optionKey)))) {
        validationErrors[`books.${index}.bookId`] = "Select a book for this exam";
      }

      if (Number(item.purchased) <= 0) {
        validationErrors[`books.${index}.purchased`] =
          "Qty Purchased must be greater than 0";
      }

      if (
        isEdit &&
        Number(item.returnBooks || 0) > Number(item.purchased || 0)
      ) {
        validationErrors[`books.${index}.returnBooks`] =
          "Return Books cannot be greater than Qty Purchased";
      }
    });

    if (Object.keys(validationErrors).length > 0) {
      setFieldErrors(validationErrors);
      showMessage(Object.values(validationErrors)[0] || "Please complete the required fields");
      return;
    }

    setFieldErrors({});

      // ======================================

      // MAIN ASSIGNMENT ID

      // ======================================



      const assignmentId =

        Number(

          initial?.id ??

          initial?.Id ??

          initial?.assignBookId ??

          initial?.AssignBookId ??

          0

        );



      if (

        isEdit &&

        !assignmentId

      ) {

        showMessage(

          "Invalid Teacher Book Assign Id"

        );



        return;

      }



      try {

        setSaving(

          true

        );



        // ====================================

        // DETAILS

        // ====================================



        const details =

          bookItems.map(

            (item) => {

              const amount =

                Number(

                  item.amount

                ) || 0;



              const qty =

                Number(

                  item.purchased

                ) || 0;



              const returnQty =

                isEdit

                  ? Number(

                    item.returnBooks

                  ) || 0

                  : 0;



              const detailId =

                isEdit

                  ? Number(

                    item?.id ??

                    item?.Id ??

                    0

                  )

                  : 0;



              const assignBookId =

                isEdit

                  ? Number(

                    item?.assignBookId ??

                    item?.AssignBookId ??

                    assignmentId

                  ) ||

                  assignmentId

                  : 0;



              return {

                Id:

                  detailId,



                AssignBookId:

                  assignBookId,



                BookId:

                  Number(

                    item.bookId

                  ),



                Amount:

                  amount,

                CourierCharges: f.deliveryMethod === "Courier" ? COURIER_CHARGE_PER_BOOK : 0,

                Qty:

                  qty,



                ReturnQty:

                  returnQty,



                ReturnAmount:

                  isEdit

                    ? amount *

                    returnQty

                    : 0,



                Description:

                  f.notes || item.notes || "",



                IsActive:

                  item?.isActive ??

                  true,

              };

            }

          );



        // ====================================

        // TOTAL AMOUNT

        // ====================================



        const totalAmount =

          details.reduce(

            (

              total,

              item

            ) =>

              total +

              Number(

                item.Amount ||

                0

              ) *

              Number(

                item.Qty ||

                0

              ) + Number(item.CourierCharges || 0),

            0

          );



        // ====================================

        // DESCRIPTION

        // ====================================



        const originalNotes = String(f.notes || "").trim() ||
          bookItems.map((item) => String(item.notes || "").trim()).filter(Boolean).join(" | ");
        const mainDescription = `${DELIVERY_PREFIX}${f.deliveryMethod}]${originalNotes ? ` | ${originalNotes}` : ""}`;

        // ====================================

        // STUDENT COUNT

        // ====================================



        const studentCount =

          bookItems.reduce(

            (

              total,

              item

            ) =>

              total +

              (

                Number(

                  item.students

                ) || 0

              ),

            0

          );



        // ====================================

        // DOCUMENT DATE

        // ====================================



        const documentDate =

          bookItems.find(

            (item) =>

              item.purchaseDate

          )?.purchaseDate ||

          "";



        // ====================================

        // API PAYLOAD

        // ====================================



        const payload = {

          Id:

            isEdit

              ? assignmentId

              : 0,



          TeacherId:

            Number(

              f.teacherId

            ),



          SchoolId:

            Number(

              f.schoolId

            ),


          CompetitiveExams: f.examName,

          DocumentNo:

            initial?.documentNo ??

            initial?.DocumentNo ??

            "",



          DocumentDate:

            documentDate,



          StudentCount:

            studentCount,



          Description:

            mainDescription,



          TotalAmount:

            totalAmount,



          IsActive:

            isEdit

              ? (

                initial?.isActive ??

                initial?.IsActive ??

                true

              )

              : true,



          teaBooAssDetlst:

            details,

        };



        // ====================================

        // EDIT MODE - UPDATE API

        // ====================================



        if (isEdit) {

          console.log(

            "Update Teacher Book Assign Request:",

            payload

          );



          const response =

            await apiService.put(

              UPDATE_TEACHER_BOOK_ASSIGN_API,

              payload

            );



          const result =

            response?.data ??

            response;



          console.log(

            "Update Teacher Book Assign Response:",

            result

          );



          const isSuccess =

            result?.isSuccess ??

            result?.IsSuccess ??

            true;



          if (

            isSuccess === false

          ) {

            throw new Error(

              result?.failureReason ??

              result?.FailureReason ??

              result?.message ??

              result?.Message ??

              "Failed to update book purchase"

            );

          }



          showMessage(

            result?.message ||

              result?.Message ||

              "Book purchase updated successfully!",

            "suc"

          );



          const formData =

            buildFormData();



          if (onSave) {

            await onSave({

              ...formData,



              id:

                assignmentId,



              assignBookId:

                assignmentId,



              documentDate,



              purchaseDate:

                documentDate,



              studentCount,



              students:

                studentCount,



              description:

                mainDescription,



              notes:

                mainDescription,



              totalAmount,



              books:

                details.map(

                  (

                    detail,

                    index

                  ) => ({

                    ...formData

                      .books[index],



                    id:

                      detail.Id,



                    assignBookId:

                      detail.AssignBookId,



                    bookId:

                      detail.BookId,



                    amount:

                      detail.Amount,

                    courierCharges: detail.CourierCharges,



                    purchased:

                      detail.Qty,



                    qty:

                      detail.Qty,



                    returnBooks:

                      detail.ReturnQty,



                    returnQty:

                      detail.ReturnQty,



                    returnAmount:

                      detail.ReturnAmount,



                    description:

                      detail.Description,



                    notes:

                      detail.Description,



                    isActive:

                      detail.IsActive,

                  })

                ),



              apiSaved:

                true,



              apiResponse:

                result,

            });

          } else {

            onBack?.();

          }



          return;

        }



        // ====================================

        // ADD MODE API

        // ====================================



        console.log(

          "Add Teacher Book Assign Request:",

          payload

        );



        const response =

          await apiService.post(

            ADD_TEACHER_BOOK_ASSIGN_API,

            payload

          );



        const result =

          response?.data ??

          response;



        console.log(

          "Add Teacher Book Assign Response:",

          result

        );



        const isSuccess =

          result?.isSuccess ??

          result?.IsSuccess ??

          true;



        if (

          isSuccess === false

        ) {

          throw new Error(

            result?.failureReason ??

            result?.FailureReason ??

            result?.message ??

            result?.Message ??

            "Failed to add book purchase"

          );

        }



        showMessage(

          result?.message ||

            result?.Message ||

            "Book purchase added successfully!",

          "suc"

        );



        const formData =

          buildFormData();



        if (onSave) {

          await onSave({

            ...formData,



            apiSaved:

              true,



            apiResponse:

              result,

          });

        } else {

          onBack?.();

        }

      } catch (error) {

        console.error(

          isEdit

            ? "Update Teacher Book Assign Error:"

            : "Add Teacher Book Assign Error:",

          error

        );



        console.log(

          "SAVE STATUS:",

          error?.response?.status

        );



        console.log(

          "SAVE RESPONSE DATA:",

          error?.response?.data

        );



        const apiError =

          error?.response?.data;



        const message =

          typeof apiError ===

            "string"

            ? apiError

            : apiError

              ?.failureReason ??

            apiError

              ?.FailureReason ??

            apiError

              ?.message ??

            apiError

              ?.Message ??

            error?.message ??

            (

              isEdit

                ? "Unable to update book purchase"

                : "Unable to add book purchase"

            );



        showMessage(

          message,

          "err"

        );

      } finally {

        setSaving(

          false

        );

      }

    };



  const renderFieldError = (name) => {
    if (!fieldErrors?.[name]) return null;

    return (
      <div
        style={{
          color: "#dc2626",
          fontSize: 10.5,
          marginTop: 4,
        }}
      >
        {fieldErrors[name]}
      </div>
    );
  };

  const renderBookFieldError = (index, name) =>
    renderFieldError(`books.${index}.${name}`);

  // ==========================================

  // UI

  // ==========================================



  return (

    <>

      <BC

        items={[

          "Books",



          isEdit

            ? "Edit Book Record"

            : "Add Book Record",

        ]}

        onBack={onBack}

      />



      <div

        className="card cp"

        style={{

          maxWidth:

            680,

        }}

      >

        {/* TITLE */}



        <div

          style={{

            fontWeight:

              700,



            fontSize:

              15,



            marginBottom:

              18,

          }}

        >

          {isEdit

            ? "Edit Book Record"

            : "Add Book Record"}

        </div>



        {/* ====================================== */}

        {/* ASSIGNMENT */}

        {/* ====================================== */}



        <div className="fsec">

          <div className="fsec-t">

            <I

              n="teacher"

              s={14}

              c="var(--p)"

            />



            Assignment

          </div>



          <div className="fgrid">

            {/* ================================== */}

            {/* TEACHER */}

            {/* ================================== */}



            <div className="fg">

              <label className="fl">

                Assign to Teacher *

              </label>



              <select

                className="fi"

                value={

                  f.teacherId

                }

                disabled={

                  saving ||

                  masterLoading

                }

                onChange={(

                  event

                ) =>

                  handleTeacher(

                    event.target

                      .value

                  )

                }

              >

                <option value="">

                  {masterLoading

                    ? "Loading teachers..."

                    : "Select teacher…"}

                </option>



                {teacherOptions.map(

                  (

                    teacher

                  ) => (

                    <option

                      key={

                        teacher.id

                      }

                      value={

                        teacher.id

                      }

                    >

                      {

                        teacher.name

                      }

                    </option>

                  )

                )}

              </select>
              {renderFieldError("schoolId")}
              {renderFieldError("teacherId")}



              {!masterLoading &&

                teacherOptions.length ===

                0 && (

                  <div

                    style={{

                      marginTop:

                        4,



                      fontSize:

                        11,



                      color:

                        "#ef4444",

                    }}

                  >

                    No active teachers found

                  </div>

                )}

            </div>



            {/* ================================== */}

            {/* SCHOOL */}

            {/* ================================== */}



            <div className="fg">

              <label className="fl">

                School *

              </label>



              <select

                className="fi"

                value={

                  f.schoolId

                }

                disabled={

                  saving ||

                  masterLoading

                }

                onChange={(

                  event

                ) =>

                  handleSchool(

                    event.target

                      .value

                  )

                }

              >

                <option value="">

                  {masterLoading

                    ? "Loading schools..."

                    : "Select school…"}

                </option>



                {schoolOptions.map(

                  (

                    school

                  ) => (

                    <option

                      key={

                        school.id

                      }

                      value={

                        school.id

                      }

                    >

                      {

                        school.schoolName

                      }

                    </option>

                  )

                )}

              </select>



              {!masterLoading &&

                schoolOptions.length ===

                0 && (

                  <div

                    style={{

                      marginTop:

                        4,



                      fontSize:

                        11,



                      color:

                        "#ef4444",

                    }}

                  >

                    No active schools found

                  </div>

                )}

            </div>

            <div className="fg">
              <label className="fl">Competitive Exam *</label>
              <select className="fi" value={f.examName}
                disabled={saving || masterLoading || booksLoading}
                onChange={(event) => handleExam(event.target.value)}>
                <option value="">Select Competitive Exam</option>
                {examOptions.map((exam) => <option key={exam} value={exam}>{exam}</option>)}
              </select>
              {renderFieldError("examName")}
              {!booksLoading && !examOptions.length && (
                <div style={{ fontSize: 11, color: "#dc2626", marginTop: 4 }}>No active exams with books found</div>
              )}
            </div>

            <div className="fg fall">
              <label className="fl">Delivery Method *</label>
              <select
                className="fi"
                value={f.deliveryMethod}
                disabled={saving}
                onChange={(event) => {
                  setF((previous) => ({ ...previous, deliveryMethod: event.target.value }));
                  setFieldErrors((previous) => ({ ...previous, deliveryMethod: undefined }));
                }}
              >
                <option value="">Select delivery method</option>
                <option value="Courier">Courier</option>
                <option value="Shop Pickup">Pick Up from Store</option>
              </select>
              {renderFieldError("deliveryMethod")}
              {f.deliveryMethod === "Courier" && (
                <div
                  role="note"
                  style={{ marginTop: 7, fontSize: 12, color: "#92400e", background: "#fffbeb", border: "1px solid #fde68a", borderRadius: 6, padding: "8px 10px" }}
                >
                  Note: A courier charge of ₹{COURIER_CHARGE_PER_BOOK} per book will be added to the total amount.
                </div>
              )}
            </div>

            <div className="fg fall">
              <label className="fl">Notes</label>
              <textarea className="fi" rows={2} value={f.notes}
                disabled={saving}
                onChange={(event) => setF((previous) => ({ ...previous, notes: event.target.value }))}
                placeholder="Add notes for this assignment..." />
            </div>

          </div>

        </div>



        {/* ====================================== */}

        {/* BOOK INFORMATION */}

        {/* ====================================== */}



        <div className="fsec">

          {/* HEADER */}



          <div

            className="fsec-t"

            style={{

              display:

                "flex",



              alignItems:

                "center",



              justifyContent:

                "space-between",

            }}

          >

            <div

              style={{

                display:

                  "flex",



                alignItems:

                  "center",



                gap:

                  6,

              }}

            >

              <I

                n="book"

                s={14}

                c="var(--p)"

              />



              Book Information

            </div>



            {!isEdit && (
            <button

              type="button"

              className="btn btn-p btn-sm"

              title="Add Another Book"

              disabled={

                saving ||

                masterLoading

              }

              onClick={addBook}

              style={{

                minWidth:

                  30,



                width:

                  30,



                height:

                  30,



                padding:

                  0,



                display:

                  "flex",



                alignItems:

                  "center",



                justifyContent:

                  "center",

              }}

            >

              <I

                n="plus"

                s={14}

                c="#fff"

              />

            </button>
            )}

          </div>



          {/* ====================================== */}

          {f.examName && (
            <div style={{ padding: "11px 13px", marginBottom: 14, background: "#eff6ff", borderRadius: 8,
              fontSize: 12, color: "#1e40af" }}>
              <strong>{f.examName}</strong> — {filteredBookOptions.length} available book(s)
              {filteredBookOptions.length > 0 && (
                <div style={{ marginTop: 6, color: "#334155" }}>
                  {filteredBookOptions.map((b) => b.bookName).join(", ")}
                </div>
              )}
            </div>
          )}

          {/* BOOK ITEMS */}

          {/* ====================================== */}



          {bookItems.map(

            (

              item,

              index

            ) => (

              <div

                key={

                  item.rowId

                }

                style={{

                  border:

                    "1px solid #e5e7eb",



                  borderRadius:

                    "var(--r3)",



                  padding:

                    14,



                  marginBottom:

                    14,



                  background:

                    "#fff",

                }}

              >

                {/* BOOK HEADER */}



                <div

                  style={{

                    display:

                      "flex",



                    alignItems:

                      "center",



                    justifyContent:

                      "space-between",



                    marginBottom:

                      13,

                  }}

                >

                  <div

                    style={{

                      fontSize:

                        12.5,



                      fontWeight:

                        700,



                      color:

                        "var(--t2)",

                    }}

                  >

                    Book{" "}

                    {index + 1}

                  </div>



                  {!isEdit && bookItems.length >

                    1 && (

                      <button

                        type="button"

                        className="btn btn-d btn-sm"

                        title="Remove Book"

                        disabled={

                          saving

                        }

                        onClick={() =>

                          removeBook(

                            index

                          )

                        }

                      >

                        <I

                          n="trash"

                          s={11}

                        />

                      </button>

                    )}

                </div>



                <div className="fgrid">

                  {/* ============================== */}

                  {/* BOOK DROPDOWN */}

                  {/* ============================== */}



                  <div className="fg fall">

                    <label className="fl">

                      Book Name *

                    </label>



                    <select

                      className="fi"

                      value={item.optionKey || (filteredBookOptions.find((opt) => String(opt.id) === String(item.bookId))?.optionKey ?? "")}

                      disabled={

                        saving ||

                        masterLoading || booksLoading || !f.examName

                      }

                      onChange={(

                        event

                      ) =>

                        handleBook(

                          index,

                          event.target

                            .value

                        )

                      }

                    >

                      <option value="">

                        {booksLoading ? "Loading books..." : !f.examName ? "Select exam first" : "Select book…"}

                      </option>



                      {filteredBookOptions.map(

                        (

                          book

                        ) => (

                          <option

                            key={

                              book.optionKey

                            }

                            value={

                              book.optionKey

                            }
                            disabled={bookItems.some((otherItem, otherIndex) =>
                              otherIndex !== index &&
                              String(otherItem.optionKey || "") === String(book.optionKey)
                            )}

                          >

                            {

                              book.bookName

                            }



                            {book.bookCode

                              ? ` - ${book.bookCode}`

                              : ""}

                          </option>

                        )

                      )}

                    </select>
                    {renderBookFieldError(index, "bookId")}



                    {!masterLoading &&

                      filteredBookOptions.length ===

                      0 && (

                        <div

                          style={{

                            marginTop:

                              4,



                            fontSize:

                              11,



                            color:

                              "#ef4444",

                          }}

                        >

                          No books found for this exam

                        </div>

                      )}

                  </div>



                  {/* ============================== */}

                  {/* PURCHASE DATE */}

                  {/* ============================== */}



                  <div className="fg">

                    <label className="fl">

                      Purchase Date

                    </label>



                    <input

                      className="fi"

                      type="date"

                      max={getTodayLocal()}

                      value={

                        item.purchaseDate

                      }

                      disabled={

                        saving

                      }

                      onChange={(

                        event

                      ) =>

                        updateBook(

                          index,

                          "purchaseDate",

                          event.target

                            .value

                        )

                      }

                    />
                    {renderBookFieldError(index, "purchaseDate")}

                  </div>



                  {/* ============================== */}

                  {/* QTY */}

                  {/* ============================== */}



                  <div className="fg">

                    <label className="fl">

                      Qty Purchased *

                    </label>



                    <input

                      className="fi"

                      type="number"

                      min={0}

                      value={

                        item.purchased

                      }

                      disabled={

                        saving

                      }

                      onChange={(

                        event

                      ) =>

                        updateBook(

                          index,

                          "purchased",

                          Number(

                            event.target

                              .value

                          )

                        )

                      }

                    />

                  </div>



                  {/* ============================== */}

                  {/* STUDENT COUNT */}

                  {/* ============================== */}



                  <div className="fg">

                    <label className="fl">

                      Student Count

                    </label>



                    <input

                      className="fi"

                      type="number"

                      min={0}

                      value={

                        item.students

                      }

                      disabled={

                        saving

                      }

                      onChange={(

                        event

                      ) =>

                        updateBook(

                          index,

                          "students",

                          Number(

                            event.target

                              .value

                          )

                        )

                      }

                    />

                  </div>



                  {/* ============================== */}

                  {/* RETURN BOOKS - EDIT ONLY */}

                  {/* ============================== */}



                  {isEdit && (

                    <div className="fg">

                      <label className="fl">

                        Return Books

                      </label>



                      <input

                        className="fi"

                        type="number"

                        min={0}

                        max={

                          item.purchased

                        }

                        value={

                          item.returnBooks ??

                          0

                        }

                        disabled={

                          saving

                        }

                        onChange={(

                          event

                        ) =>

                          updateBook(

                            index,

                            "returnBooks",

                            Number(

                              event

                                .target

                                .value

                            )

                          )

                        }

                      />
                    {renderBookFieldError(index, "returnBooks")}

                    </div>

                  )}



                </div>



                {/* ============================== */}

                {/* SELECTED BOOK AMOUNT */}

                {/* ============================== */}



                {item.bookId && (

                  <div

                    style={{

                      marginTop:

                        10,



                      fontSize:

                        12,



                      color:

                        "var(--t3)",

                    }}

                  >

                    Book Amount:{" "}



                    <strong

                      style={{

                        color:

                          "var(--t2)",

                      }}

                    >

                      ₹

                      {Number(

                        item.amount ||

                        0

                      ).toLocaleString(

                        "en-IN"

                      )}

                    </strong>



                    {" • "}

                    Courier Charges: <strong>₹{f.deliveryMethod === "Courier" ? COURIER_CHARGE_PER_BOOK : 0}</strong>

                    {" • "}

                    Total:{" "}



                    <strong

                      style={{

                        color:

                          "var(--p)",

                      }}

                    >

                      ₹

                      {(

                        Number(

                          item.amount ||

                          0

                        ) *

                        Number(

                          item.purchased ||

                          0

                        ) + (f.deliveryMethod === "Courier" ? COURIER_CHARGE_PER_BOOK : 0)

                      ).toLocaleString(

                        "en-IN"

                      )}

                    </strong>

                  </div>

                )}



                {/* ============================== */}

                {/* STOCK STATUS */}

                {/* ============================== */}



                {item.purchased >

                  0 && (

                    <div

                      style={{

                        marginTop:

                          11,



                        padding:

                          "9px 12px",



                        borderRadius:

                          "var(--r3)",



                        background:

                          item.purchased <

                            40

                            ? "#FEF2F2"

                            : item.purchased <

                              48

                              ? "#FFFBEB"

                              : "#ECFDF5",



                        border: `1px solid ${item.purchased <

                          40

                          ? "#FECACA"

                          : item.purchased <

                            48

                            ? "#FDE68A"

                            : "#A7F3D0"

                          }`,

                      }}

                    >

                      <span

                        style={{

                          fontWeight:

                            600,



                          fontSize:

                            12.5,



                          color:

                            item.purchased <

                              40

                              ? "#EF4444"

                              : item.purchased <

                                48

                                ? "#F59E0B"

                                : "#10B981",

                        }}

                      >

                        {item.purchased <

                          40

                          ? "⚠ Critical stock level"

                          : item.purchased <

                            48

                            ? "⚠ Low stock — consider ordering more"

                            : "✓ Sufficient stock level"}

                      </span>

                    </div>

                  )}

              </div>

            )

          )}



          {/* ====================================== */}

          {/* ADD ANOTHER BOOK (Add mode only) */}

          {/* ====================================== */}

          {!isEdit && (
          <button

            type="button"

            className="btn btn-g"

            disabled={

              saving ||

              masterLoading

            }

            onClick={

              addBook

            }

            style={{

              marginTop:

                2,

            }}

          >

            <I

              n="plus"

              s={12}

            />



            Add Another Book

          </button>
          )}

        </div>



        {/* ====================================== */}

        {/* BUTTONS */}

        {/* ====================================== */}

        {Object.keys(fieldErrors).length > 0 && (
          <div role="alert" style={{color:"#b91c1c",fontSize:12,marginBottom:12}}>
            Please correct the highlighted fields before {isEdit ? "updating" : "saving"}.
          </div>
        )}

        <div

          style={{

            display:

              "flex",



            gap:

              9,

          }}

        >

          <button

            type="button"

            className="btn btn-p"

            disabled={

              saving ||

              masterLoading

            }

            onClick={

              handleSave

            }

          >

            <I

              n="check"

              s={13}

              c="#fff"

            />



            {saving

              ? " Saving..."

              : isEdit

                ? " Update Book Record"

                : " Add Book Record"}

          </button>



          <button

            type="button"

            className="btn btn-g"

            disabled={

              saving

            }

            onClick={

              onBack

            }

          >

            Cancel

          </button>

        </div>

      </div>

    </>

  );

}